<app-search-wrap
  [persistent]="true"
  (open)="openSearch()"
  (close)="closeSearch()"
  (onSearch)="search($event)"
  [title]="i18n.instant('home.fridges')"
></app-search-wrap>

<div class="status-filters">
  <button
    class="status-filters__btn"
    [class.active]="statusFilter === 'all'"
    (click)="setStatusFilter('all')"
  >{{ 'home.filter_all' | translate }}</button>
  <button
    class="status-filters__btn"
    [class.active]="statusFilter === 'online'"
    (click)="setStatusFilter('online')"
  >{{ 'home.filter_online' | translate }}</button>
  <button
    class="status-filters__btn"
    [class.active]="statusFilter === 'offline'"
    (click)="setStatusFilter('offline')"
  >{{ 'home.filter_offline' | translate }}</button>
</div>

@if (fridgeList) {
  <div class="fridge-list">
    @if (onlineList.length) {
      <div class="fridge-group">
        <div class="fridge-group__header">
          <span class="dot green"></span>
          {{ 'home.online' | translate }} ({{ onlineList.length }})
        </div>
        @for (fridge of onlineList; track fridge._id) {
          <app-fridge-list [fridge]="fridge" (selectFridge)="select.emit($event)"></app-fridge-list>
        }
      </div>
    }
    @if (offlineList.length) {
      <div class="fridge-group">
        <div class="fridge-group__header" (click)="toggleOfflineGroup()">
          <span class="dot red"></span>
          {{ 'home.offline' | translate }} ({{ offlineList.length }})
          <span class="fridge-group__toggle">{{ offlineCollapsed ? '▾' : '▴' }}</span>
        </div>
        @if (!offlineCollapsed) {
          @for (fridge of offlineList; track fridge._id) {
            <app-fridge-list [fridge]="fridge" (selectFridge)="select.emit($event)"></app-fridge-list>
          }
        }
      </div>
    }
    @if (!onlineList.length && !offlineList.length) {
      <div class="fridge-list__empty">{{ 'home.no_fridges' | translate }}</div>
    }
  </div>
}
